import React, { useState } from 'react';
import { StyledButtonMerge } from '../styles';
import { useModalContext } from '../../../../../components/CustomModal/ModalProvider';
import { blockchainService } from '../../../../../services/blockchainService';

export const MergeArquivo = ({ projectId, modeloDocumentId, modeloTopicId, recarregaMerge }) => {
  const token = sessionStorage.getItem('Authorization');
  const headers = { Authorization: `Bearer ${token}` };
  const [loading, setLoading] = useState(false);
  const [documentMergeStatus, setDocumentMergeStatus] = useState({});
  const { showWarning, showConfirm, showSuccess, showError, showLoading, hideModal } = useModalContext();
  const [mensagem, setMensagem] = useState('');
  const [error, setError] = useState('');

  const showMergePreview = (pdfBase64, onConfirm) => {
    try {
      // Converte o PDF base64 em Blob para exibir no link
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);


      // Exibe o modal de confirmação usando showConfirm (Promise)
      showConfirm(
        'Documento Mesclado',
        <div>
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            Visualizar Documento
          </a>
          <div>Deseja salvar o merge?</div>
        </div>
      )
        .then((confirm) => {
          if (!confirm) {
            hideModal();
            return;
          }
          hideModal();

          if (onConfirm) {
            onConfirm();
          }
        })
        .catch((error) => {
          console.error('❌ Erro ao exibir modal de confirmação:', error);
          hideModal();
        });
    } catch (err) {
      console.error('❌ Erro ao processar PDF base64:', err);
      showError('Erro!', 'Falha ao processar o documento mesclado.');
    }
  };


  const handleMerge = async () => {
    showLoading('Iniciando mesclagem...', 'Preparando os documentos...');

    setLoading(true);
    setMensagem('');
    setError('');

    try {
      // 1️⃣ Buscar documentos ativos
      const { merge_ativo, documentos } = await blockchainService.getActiveDocuments(
        projectId,
        modeloDocumentId,
        modeloTopicId,
        headers
      );

      if (merge_ativo) {
        hideModal();
        showError('Merge Ativo', '⚠️ Já existe um merge ativo para este tópico.');
        setLoading(false);
        return;
      }

      if (documentos.length === 0) {
        hideModal();
        showWarning('Nenhum Documento', '⚠️ Nenhum documento ativo encontrado para este tópico.');
        setLoading(false);
        return;
      }

      // 2️⃣ Gerar merge
      const { pdf_base64: base64, merge_guid: mergeGuid } =
        await blockchainService.generateMergeDocuments(
          projectId,
          modeloDocumentId,
          modeloTopicId,
          headers
        );

      hideModal();
      showMergePreview(base64, async () => {
        try {
          // 3️⃣ Salvar merge
          const documentIds = documentos.map((doc) => doc.id);
          const saveResponse = await blockchainService.saveMergeDocuments(
            projectId,
            modeloDocumentId,
            modeloTopicId,
            base64,
            mergeGuid,
            documentIds,
            headers
          );

          if (saveResponse.status === 201) {
            const novoStatus = { ...documentMergeStatus };
            documentIds.forEach((id) => {
              novoStatus[id] = true;
            });
            setDocumentMergeStatus(novoStatus);
            showSuccess('Merge salvo com sucesso!', 'O documento foi salvo com sucesso.');
            if (recarregaMerge) recarregaMerge();
          }
        } catch (err) {
          showError('Erro ao salvar merge', err.response?.data?.error || 'Erro desconhecido.');
        }
      });
    } catch (err) {
      console.error('❌ Erro ao gerar merge:', err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMergeWithConfirm = () => {
    showConfirm(
      'Iniciar Mesclagem',
      'Deseja realmente gerar a mesclagem para este tópico?'
    )
      .then((confirm) => {
        if (!confirm) {
          return;
        }

        hideModal(); // Fecha o modal (caso ainda esteja aberto)

        // Pequeno delay opcional antes de executar a mesclagem
        setTimeout(() => {
          handleMerge();
        }, 200);
      })
      .catch((error) => {
        console.error('❌ Erro inesperado ao confirmar mesclagem:', error);
      });
  };


  return (
    <div>
      <StyledButtonMerge onClick={handleMergeWithConfirm} disabled={loading} style={{ cursor: 'pointer' }}>
        {loading ? 'Gerando Mesclagem...' : 'Mesclar'}
      </StyledButtonMerge>
    </div>
  );
};


